import { render, staticRenderFns } from "./PainterSuperTalkDetails.vue?vue&type=template&id=18dadbca&scoped=true"
import script from "./PainterSuperTalkDetails.vue?vue&type=script&lang=js"
export * from "./PainterSuperTalkDetails.vue?vue&type=script&lang=js"
import style0 from "./PainterSuperTalkDetails.vue?vue&type=style&index=0&id=18dadbca&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18dadbca",
  null
  
)

export default component.exports